<ng-container [ngSwitch]="statusPrompt">
  <div *ngSwitchCase="'WaitingForAssessment'" class="waiting-on-instructor">
    <es-icon name="clock"></es-icon>
    <h2 translate>Waiting for Assessment</h2>
  </div>
  <div *ngSwitchCase="'Completed'" class="waiting-on-instructor completed">
    <es-icon name="check"></es-icon>
    <h2 translate>Assessment Complete</h2>
    <p translate>
      You have completed the assessment. No further action is required.
    </p>
  </div>
  <es-modal
    id="esModal"
    *ngIf="displayPopup"
    (esModalClose)="togglePollOptions(null)"
  >
    <h3 translate>Choose Assessment</h3>
    <es-list-item
      *ngFor="let poll of popupOptions"
      name="{{ poll.name }}"
      caption="{{ poll.caption }}"
      (click)="goToPoll(poll.id)"
    ></es-list-item>
  </es-modal>
</ng-container>
